<template>
  <div class="w-100">
    <slot></slot>
    
    <ok-cancel-dialog id="generate-random-pass-modal"
                      title="Generar contraseña aleatoria"
                      content="<p>¿Está seguro de generar una contraseña aleatoria para el usuario?. La contraseña actual quedará invalidada después de esta acción</p>"
                      ok-button-text="Confirmar generación de contraseña"
                      :ok-callback="generateRandomPassword"
                      ref="generate-random-pass-modal"></ok-cancel-dialog>
  </div>
</template>

<script>
  import OkCancelDialog from '../components/ui/OkCancelDialog'
  import 'jquery-validation'
  import { mapActions } from 'vuex'
  import { AlertManager } from '../components/utils/AlertManager'
  import 'select2'
  import 'select2/dist/js/i18n/es'
  import 'flatpickr'
  import 'flatpickr/dist/flatpickr.min.css'
  import { Spanish } from 'flatpickr/dist/l10n/es'
  
  export default {
    name: 'RegisterUser',
    components: {
      OkCancelDialog,
    },
    props: ['user'],
    methods: {
      ...mapActions({
        generatePassword: 'users/generatePassword',
      }),
      
      showGeneratePasswordModal () {
        $(this.$refs['generate-random-pass-modal']).modal('show')
      },
      async generateRandomPassword () {
        const response = await this.generatePassword({
          user: this.user,
        })
        
        if (response) {
          const {
                  message,
                  status,
                  error,
                } = response.data.data
          
          if (status === 'error') {
            AlertManager.error(error)
            
            $('#generate-random-pass-modal').modal('hide')
            
            return
          }
          
          AlertManager.success(message)
          
          $('#generate-random-pass-modal').modal('hide')
        }
      },
    },
    mounted () {
      /**
       * Init Select2 for Job Types
       */
      const jobTypes = $('.search-job-types')
      
      jobTypes.select2({
        language: {
          noResults: function () {
            return 'Aún no ha ingresado ningún valor'
          },
        },
      })
      
      /**
       * Init Select2 for roles
       */
      const roles = $('.search-roles')
      
      roles.select2({
        placeholder: 'Seleccione los roles',
        language: {
          noResults: function () {
            return 'Aún no ha ingresado ningún valor'
          },
        },
      })

      /**
       * Init Select2 for institutions
       */
      const institutions = $('.search-institution')
      
      institutions.select2({
        language: {
          noResults: function () {
            return 'Aún no ha ingresado ningún valor'
          },
        },
      })
      
      /**
       * Init JQuery validation
       */
      $(() => {
        const $search = $('#secondment_id')
        $search.select2()
        
        $('#birthdate, #start_date').flatpickr({
          disableMobile: false,
          dateFormat: 'd/m/Y',
          locale: Spanish,
        })
        
        $('.form').validate({
          ignore: [],
          highlight: function (element, errorClass, validClass) {
            $(element).addClass('is-invalid')
          },
          unhighlight: function (element, errorClass, validClass) {
            $(element).removeClass('is-invalid')
          },
          errorPlacement: function (label, element) {
            label.addClass('invalid-feedback')
            label.insertAfter(element)
          },
          rules: {
            user_type: {
              required: true,
            },
            avatar: {
              accept: 'image/*',
              extension: 'jpg|JPG|jpeg|JPEG|png|PNG',
              maxsize: 2 * 1024 * 1024,
            },
            'roles[]': {
              required: true,
            },
            first_name: {
              required: function () {
                return $('#user_type').val() === 'externo' || $('#user_type').val() === 'honorario'
              },
            },
            last_name: {
              required: function () {
                return $('#user_type').val() === 'externo' || $('#user_type').val() === 'honorario'
              },
            },
            family_name: {
              required: function () {
                return $('#user_type').val() === 'externo' || $('#user_type').val() === 'honorario'
              },
            },
            external_institution_id: {
              required: function () {
                return $('#user_type').val() === 'externo'
              },
            },
            external_institution_other: {
              required: function () {
                return parseInt($('#external_institution_id').val()) === 474
              },
            },
            expertise_area: {
              required: function () {
                return $('#user_type').val() === 'externo'
              },
            },
            marital_status_id: {
              required: function () {
                return $('#user_type').val() === 'externo' || $('#user_type').val() === 'honorario'
              },
            },
            gender: {
              required: function () {
                return $('#user_type').val() === 'externo' || $('#user_type').val() === 'honorario'
              },
            },
            email: {
              required: function () {
                return $('#user_type').val() === 'externo' || $('#user_type').val() === 'honorario'
              },
              email: true,
            },//
            secondment_id: {
              required: function () {
                return $('#user_type').val() === 'honorario'
              },
            },
            classification_id: {
              required: function () {
                return $('#user_type').val() === 'honorario'
              },
            },
            workplace_id: {
              required: function () {
                return $('#user_type').val() === 'honorario'
              },
            },
            venue_id: {
              required: function () {
                return $('#user_type').val() === 'honorario'
              },
            },
            birthdate: {
              required: function () {
                return $('#user_type').val() === 'honorario'
              },
            },
            start_date: {
              required: function () {
                return $('#user_type').val() === 'honorario'
              },
            },
            nationality: {
              required: function () {
                return $('#user_type').val() === 'honorario'
              },
            },
          },
          messages: {
            user_type: {
              required: 'Este campo es requerido.',
            },
            avatar: {
              accept: 'El archivo debe ser una imagen.',
              extension: 'Extensión de archivo no valida.',
              maxsize: 'El tamaño del archivo no debe superar los 2 MB.',
            },
            'roles[]': {
              required: 'Este campo es requerido.',
            },
            first_name: {
              required: 'Este campo es requerido.',
            },
            last_name: {
              required: 'Este campo es requerido.',
            },
            family_name: {
              required: 'Este campo es requerido.',
            },
            external_institution_id: {
              required: 'Este campo es requerido.',
            },
            external_institution_other: {
              required: 'Este campo es requerido.',
            },
            expertise_area: {
              required: 'Este campo es requerido.',
            },
            marital_status_id: {
              required: 'Este campo es requerido.',
            },
            gender: {
              required: 'Este campo es requerido.',
            },
            email: {
              required: 'Este campo es requerido.',
              email: 'Formato de correo invalido.',
            },
            secondment_id: {
              required: 'Este campo es requerido.',
            },
            classification_id: {
              required: 'Este campo es requerido.',
            },
            workplace_id: {
              required: 'Este campo es requerido.',
            },
            venue_id: {
              required: 'Este campo es requerido.',
            },
            birthdate: {
              required: 'Este campo es requerido.',
            },
            start_date: {
              required: 'Este campo es requerido.',
            },
            nationality: {
              required: 'Este campo es requerido.',
            },
          },
          submitHandler (form) {
            $('#btn-save, #btn-cancel').prop('disabled', true)
            $('#btn-save').find('.spinner-border').removeClass('d-none')
            
            form.submit()
          },
        })
      })
      
      /**
       * User type change event
       */
      manageInputs($('#user_type').val())
      
      $('#user_type').on('change', function (e) {
        manageInputs(this.value)
      })
      
      $(() => {
        if (parseInt($('#external_institution_id').val()) === 474) {
          $('.external_institution_other_container').removeClass('d-none').addClass('show')
        }
      })
      
      $('#external_institution_id').on('change', function (e) {
        if (parseInt($(this).val()) === 474) {
          $('.external_institution_other_container').removeClass('d-none').addClass('show')
        }
        else {
          $('.external_institution_other_container').removeClass('show').addClass('d-none')
        }
      })
      
      function manageInputs (value) {
        switch (value) {
          case 'base':
            $('.c-input.base').removeClass('d-none')
            $('.c-input').not('.base').addClass('d-none')
            $('.c-input.base input, .c-input.base select').attr('disabled', 'disabled')
            break
          case 'alumno':
            $('.c-input.alumno').removeClass('d-none')
            $('.c-input').not('.alumno').addClass('d-none')
            $('.c-input.alumno input, .c-input.alumno select:not(#external_institution_id').attr('disabled', 'disabled')
            break
          case 'externo':
            $('.c-input.externo').removeClass('d-none')
            $('.c-input').not('.externo').addClass('d-none')
            $('.c-input.externo input, .c-input.externo select').removeAttr('disabled', 'disabled')
            break
          case 'honorario':
            $('.c-input.honorario').removeClass('d-none')
            $('.c-input').not('.honorario').addClass('d-none')
            $('.c-input.honorario input, .c-input.honorario select').removeAttr('disabled', 'disabled')
            break
        }
        
        if (parseInt($('#external_institution_id').val()) === 474) {
          $('.external_institution_other_container').removeClass('d-none').addClass('show')
        }
      }
    },
  }
</script>
